module.exports = __webpack_public_path__ + "3349d282881145edb9267af9a2bbf2ae.png";